import React from 'react';

type Props = {};

const Filter: React.FC<Props> = () => {
  return (
    <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 3H19" stroke="#D77B8B" strokeWidth="2" />
      <path d="M0 11H19" stroke="#D77B8B" strokeWidth="2" />
      <rect x="4" width="2" height="6" fill="#D77B8B" />
      <rect x="12" y="8" width="2" height="6" fill="#D77B8B" />
    </svg>
  );
};

export default Filter;
